module.exports = __webpack_public_path__ + "static/media/21ECLAC8.56b26571.jpg";